
import { HTMLAttributes, ReactElement } from "react";

interface Props extends HTMLAttributes<HTMLElement> {
    color?: string;
}
    
     function SavedUp({ color }: Props): ReactElement {

    return (
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18.3339 9.16732C18.3263 6.57206 18.2442 5.19621 17.3583 4.3103C16.382 3.33398 14.8107 3.33398 11.668 3.33398H8.33464C5.19194 3.33398 3.62059 3.33398 2.64428 4.3103C1.66797 5.28661 1.66797 6.85795 1.66797 10.0007C1.66797 13.1433 1.66797 14.7147 2.64428 15.691C3.62059 16.6673 5.19194 16.6673 8.33464 16.6673H9.58464" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M12.9167 11.666V16.666M12.9167 16.666L14.5833 14.9993M12.9167 16.666L11.25 14.9993M16.6667 16.666V11.666M16.6667 11.666L18.3333 13.3327M16.6667 11.666L15 13.3327" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8.33333 13.334H5" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
                <path d="M1.66797 8.33398L18.3346 8.33398" stroke={color} strokeLinecap="round" />
            </svg>
        );
}

export default SavedUp;